var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabbar-page"},[_c('van-tabbar',{attrs:{"value":_vm.active}},[_c('van-tabbar-item',{attrs:{"icon":"home-o"},on:{"click":function($event){return _vm.$router.push({
        path: '/common-index',
        query: { cateId: _vm.moduleInfo.topCateId },
      })}}},[_vm._v(" 首页 ")]),_c('van-tabbar-item',{staticClass:"budo-12",attrs:{"icon":"contact-o"},on:{"click":function($event){return _vm.$router.push({ path: 'user-center-index' })}}},[_vm._v(" 我的 ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }